/**
 * pickTypes selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

interface State {
    pickTypes: {
        [string]: {
            name: string
        }
    };
}

interface Props {
    pickTypeId: number | string;
}

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectPickTypes = (state: State) => state.pickTypes;
const selectPickTypeId = (state: State, props: Props) =>
    props.pickTypeId && `${props.pickTypeId}`;

const selectPickType = createDeepEqualSelector(
    selectPickTypes,
    selectPickTypeId,
    (pickTypesState, pickTypeId) => pickTypeId && pickTypesState[pickTypeId]
);

const makeSelectPickTypeValue = (field: string) =>
    createDeepEqualSelector(
        selectPickType,
        pickTypeState => pickTypeState && pickTypeState[field]
    );

export {
    selectPickTypes,
    selectPickTypeId,
    selectPickType,
    makeSelectPickTypeValue
};
